export var EAuthenticateStatus;

(function (EAuthenticateStatus) {
  EAuthenticateStatus["Initial"] = "initial";
  EAuthenticateStatus["Loading"] = "loading";
  EAuthenticateStatus["Succeed"] = "succeed";
  EAuthenticateStatus["Failed"] = "failed";
})(EAuthenticateStatus || (EAuthenticateStatus = {}));

export var EAuthenticateError;

(function (EAuthenticateError) {
  EAuthenticateError["Common"] = "common";
  EAuthenticateError["TwoFactorRequired"] = "twoFactorRequired";
  EAuthenticateError["LimitReached"] = "limitReached";
  EAuthenticateError["TwoFactorAttemptsExhausted"] = "twoFactorAttemptsExhausted";
  EAuthenticateError["Unexpected"] = "unexpected";
})(EAuthenticateError || (EAuthenticateError = {}));